export default class ContentBlock extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-content-block', ContentBlock);
